import { observable, computed, action, runInAction } from 'mobx';
import autobind from 'autobind-decorator';
import { asyncAction } from 'mobx-utils';
import { ScoreService } from '../../../../common/services';
import TennisModel from './model';
import { ScoreUtil } from '../../../../common/utils/scoreUtil';
import WebSocketUtil from '../../../../common/utils/socketUtil';
import AbstractScoreCommon from '../../store/common';
import {getDeletedGames, setDefaultList} from "routes/score/shared/utils";

@autobind
class TennisStore extends AbstractScoreCommon {
  socket = null;
  isSub = false;

  @observable
  list = [];

  @observable
  loading = false;

  @observable
  selectedTab = 'ALL';

  constructor() {
    super();
  }

  connectSocket(topic) {
    this.socket = new WebSocketUtil(topic);

    this.socket.ws.onmessage = (event) => {
      if (event) {
        let data = event.data;

        try {
          if (data === 'OK') {
            this.isSub = true;
          } else {
            let messageData = JSON.parse(data);

            if (messageData) {
              const { TOPIC, MESSAGE } = messageData;

              if (TOPIC.includes('sports')) {
                const data = JSON.parse(MESSAGE);
                const copy = [...this.list.toJS()];
                let index = -1;

                if (data.hasOwnProperty('gameId')) {
                  index = copy.findIndex((item) => item.id === data.gameId);
                }

                if (Boolean(~index)) {
                  if (TOPIC === `sports.tennis.games`) {
                    this.list[index].updateGame(data.game);
                  }

                  if (TOPIC === `sports.tennis.period-data`) {
                    const check = this.isFavoriteActiveCheck;
                    const checkFavorite = this.selectedList.some((item) => item.id === data.gameId);

                    this.list[index].updatePeriodData(data.periodData, check, checkFavorite);
                  }

                  if (TOPIC === `sports.tennis.special`) {
                    this.list[index].updateSpecial(data.special);
                  }

                  if (TOPIC === `sports.tennis.last-broadcast`) {
                    this.list[index].updateLastBroadcast(data.broadcast);
                  }
                }

                if (TOPIC === `sports.tennis.cheers`) {
                  index = copy.findIndex((item) => item.id === parseInt(data.game_id));
                  if (Boolean(~index)) {
                    this.list[index].cheerCount++;
                  }
                }
              }
            }
          }
        } catch (error) {
          console.log('=== socket on message error ===', error);
        }
      }
    };
  }

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get tennisList() {
    const { list, selectedGames } = this;
    const deleteSelectedGames = getDeletedGames(list, selectedGames);

    return setDefaultList(deleteSelectedGames);
  }

  @computed
  get selectedList() {
    const list = this.list.toJS();
    let selectedGameList = [];

    if (this.selectedGames.length > 0) {
      selectedGameList = list.filter((item) => this.selectedGames.some((id) => id.key === item.id));
    }

    return ScoreUtil.sortSportsList(selectedGameList);
  }

  @computed
  get tennisCount() {
    const list = this.list.toJS();

    return {
      all: list.length,
      ready: list.filter((item) => item.gameStatus === 'READY').length,
      inProgress: list.filter(
        (item) => item.gameStatus === 'IN_PROGRESS' || item.gameStatus === 'BREAK_TIME' || item.gameStatus === 'PAUSE'
      ).length,
      final: list.filter(
        (item) =>
          item.gameStatus === 'FINAL' ||
          item.gameStatus === 'CUT' ||
          item.gameStatus === 'POSTPONED' ||
          item.gameStatus === 'PENDING' ||
          item.gameStatus === 'CANCEL' ||
          item.gameStatus === 'DELAY' ||
          item.gameStatus === 'SUSPENDED'
      ).length,
    };
  }

  @computed
  get isFavoriteActiveCheck() {
    const { selectedList } = this;

    return selectedList.length > 0;
  }

  /**********************************************************
   * actions
   **********************************************************/
  @action
  closeSocket() {
    this.socket.close(() => {
      runInAction(() => {
        this.isSub = false;
        this.socket = null;
      });
    });
  }

  @action
  setTennisSelectedTab(tab) {
    this.selectedTab = tab;
  }

  /**********************************************************
   * async actions
   **********************************************************/
  @asyncAction
  *getTennis(date) {
    this.loading = true;

    try {
      // TODO: 웹소켓;
      if (!this.isSub) {
        yield this.connectSocket([
          'sports.tennis.games',
          'sports.tennis.period-data',
          'sports.tennis.cheers',
        ]);
      }

      const result = yield ScoreService.getSportsTypeGames(date, 'ALL', 'tennis');

      if (result) {
        this.list = result.map((item) => new TennisModel(item));

        this.loading = false;
      }

      // console.log('result success = ', result);
      // console.log(type, ' response = ', this.sports[type]);
    } catch (error) {
      console.log(error);
    }
  }
}

export default TennisStore;
